// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/nominativi',
    requestBody: null,
    response: '{"data":[{"id":1,"ragioneSociale":"..."}],"total":0}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/unita-misura',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"simbolo":"mq","nome":"metri quadrati"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"codice":"..."}],"total":0,"page":1,"limit":25}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/collezioni',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"nome":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/prodotti',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"codice":"...","nome":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/prossimo-codice',
    requestBody: null,
    response: '{"success":true,"codice":"..."}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/articoli',
    requestBody: '{"societaId":1,"tipologia":"ARTICOLO_FISICO","codice":"...","descrizioneBase":"...","umVenditaId":1,"prodottoId":1}',
    response: '{"success":true,"data":{"id":1}}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/articoli/unita-misura',
    requestBody: '{"societaId":1,"simbolo":"mq","nome":"mq"}',
    response: '{"success":true,"data":{"id":1,"simbolo":"mq","nome":"mq"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
